import {
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core";
import React, { FunctionComponent } from "react";
import { financialItemStyles } from "./financialItemStyle";
import TableContainer from "@material-ui/core/TableContainer";
type ReturnVoucherDataProps = {
  issuedVoucherCount: string,
  issuedVoucherTotalAmount: string,
};

export const IssuedReturnVoucher: FunctionComponent<ReturnVoucherDataProps> = ({
  issuedVoucherCount,
  issuedVoucherTotalAmount,
}) => {
  const classes = financialItemStyles();
  return (
    <Grid container>
      <Grid item xs={12}>
        <TableContainer>
          <Table
            className={classes.table}
            size="small"
            aria-label="a dense table"
          >
            <TableHead className={classes.tableRow} style={{ height: "4em" }}>
              <TableRow style={{ height: "3em" }}>
                <TableCell
                  className={classes.headColor}
                  component="th"
                  scope="row"
                  style={{ width: "35%" }}
                >
                  Name
                </TableCell>
                <TableCell className={classes.deptHead} align="center">
                  Count
                </TableCell>
                <TableCell align="right" className={classes.headColor}>
                  Amount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {issuedVoucherCount && (
                <TableRow>
                  <TableCell align="left" className={classes.columnWeight}>
                    Return Voucher
                  </TableCell>
                  <TableCell align="center" className={classes.columnWeight}>
                    {issuedVoucherCount}
                  </TableCell>
                  <TableCell align="right" className={classes.columnWeight}>
                    {issuedVoucherTotalAmount}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
